import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ComponentManager } from '@ikea-aoa/ikea-shared-component';
import StopPropagation from './utils/StopPropagation';
import { default as _SeriesGallery } from '@ikea-aoa/ikea-component-series-gallery';
import isValid from '../services/PacValidator';
import fixOldVpc from '../services/FixVPC';
import storage from '../services/history/storage';
import { applicationSettings } from '../settings/application';
import { DesignSourceEnum } from '@insights/insights-data-provider';
import { thunkSetView } from '../state/navigation/navigationThunks';
import masterConstants from '../settings/masterConstants';
import { thunkResetApp } from '../state/init/initThunks';
import { closeSeriesGallery } from '../state/dialog/dialogActions.ts';
import constants from '../settings/constants';
import { selectDialog } from '../state/dialog/dialogSelectors.ts';
import { thunkLoadPac } from '../state/tac/tacThunks';
import mandatoryStatisticsReporter from '../services/statistics/insights/mandatory/mandatoryStatisticsReporter';

class SeriesGallery extends React.Component {
  static propTypes = {
    goToStart: PropTypes.func.isRequired,
    closeSeriesGallery: PropTypes.func.isRequired,
    resetApp: PropTypes.func.isRequired,
  };

  getLocalhostUrlWithNewPlanner = (currentPlanner, plannerToNavigateTo) => {
    const currentUrl = window.location.href;
    return currentUrl.replace(currentPlanner, plannerToNavigateTo);
  };

  isLocalhostEnvironment = () => {
    const url = window.location.href;
    return url.includes('localhost');
  };

  closeSeriesGalleryAndGoToStart = () => {
    this.props.closeSeriesGallery();
    this.props.goToStart();
  };

  constructor() {
    super();
    const componentManager = new ComponentManager();
    componentManager.register(_SeriesGallery);
    componentManager.connectObserver();

    this.events = _SeriesGallery.events({
      vpcDone: vpcData => {
        const pac = fixOldVpc(vpcData.configuration);
        if (isValid(pac)) {
          this.props.loadPAC(pac);
          mandatoryStatisticsReporter.reportInitialPlanningSession(
            vpcData.vpcCode,
            DesignSourceEnum.gallery
          );
        }
      },
      show: () => {
        storage.session.setItem(constants.SERIES_GALLERY_ACTIVE_KEY, true);
      },
      close: () => {
        storage.session.removeItem(constants.SERIES_GALLERY_ACTIVE_KEY);
      },
      applicationClick: click => {
        storage.session.removeItem(constants.SERIES_GALLERY_ACTIVE_KEY);
        const applicationClicked = click.application;

        const currentPlanner =
          applicationSettings.applicationName.toLocaleLowerCase();
        const plannerToNavigateTo = applicationClicked.id.toLowerCase();

        if (this.isLocalhostEnvironment()) {
          if (currentPlanner === plannerToNavigateTo) {
            this.closeSeriesGalleryAndGoToStart();
            return;
          }
          this.props.resetApp();
          window.location.href = this.getLocalhostUrlWithNewPlanner(
            currentPlanner,
            plannerToNavigateTo
          );
          window.location.reload();
          return;
        }

        if (currentPlanner === plannerToNavigateTo) {
          this.closeSeriesGalleryAndGoToStart();
        } else {
          this.props.resetApp();
          window.location.href = applicationClicked.url;
        }
      },
    });
  }

  render() {
    return (
      <StopPropagation>
        <ikea-component
          name={'SeriesGallery'}
          data-events={this.events}
          data-visible={'true'}
          data-redirect={false}
        />
      </StopPropagation>
    );
  }
}

export default connect(
  state => ({
    dialog: selectDialog(state),
  }),
  dispatch => ({
    goToStart: () => dispatch(thunkSetView(masterConstants.VIEW_NAMES.START)),
    closeSeriesGallery: () => dispatch(closeSeriesGallery()),
    resetApp: () => dispatch(thunkResetApp()),
    loadPAC: pac => dispatch(thunkLoadPac(pac)),
  })
)(SeriesGallery);
